import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(7),
  backgroundColor: theme.palette.grey.A000,
  '&.MTVContainer': {
    marginBottom: theme.spacing(3),
    overflowX: 'hidden',
  },
  '& .MotorcycleRentalsSectionContainer': {
    padding: 0,
  },
  '& .MTVSectionSpace': {
    marginBottom: theme.spacing(6),
    [theme.breakpoints.down('lg')]: {
      marginBottom: theme.spacing(3),
    },
  },
  '& .showDESKTOP': {
    [theme.breakpoints.down('lg')]: {
      display: 'none',
    },
  },
  '& .showTABLET': {
    [theme.breakpoints.up('lg')]: {
      display: 'none',
    },
  },
  '& .MTVcomparisonSection': {
    [theme.breakpoints.up('lg')]: {
      backgroundColor: theme.palette.common.white,
    },
  },
}));
export default StyledBox;
